/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Parsing_DescriptionInputs */

const en_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parsing work order description`)
};

const fr_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse de la description de l’ordre de travail`)
};

const de_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse der Arbeitsauftragsbeschreibung`)
};

const it_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi della descrizione dell'ordine di lavoro`)
};

const ru_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ описания заказа на выполнение работ`)
};

const es_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de la descripción de la orden de trabajo`)
};

const zh_cn2_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解析工单描述`)
};

const ja_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業指示書の説明を解析する`)
};

const hi_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य आदेश विवरण का विश्लेषण करना`)
};

const pt_pt2_work_order_import_status_parsing_description = /** @type {(inputs: Work_Order_Import_Status_Parsing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisando a descrição da ordem de serviço`)
};

/**
* | output |
* | --- |
* | "Parsing work order description" |
*
* @param {Work_Order_Import_Status_Parsing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_parsing_description = /** @type {((inputs?: Work_Order_Import_Status_Parsing_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Parsing_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_status_parsing_description(inputs)
	if (locale === "de") return de_work_order_import_status_parsing_description(inputs)
	if (locale === "it") return it_work_order_import_status_parsing_description(inputs)
	if (locale === "ru") return ru_work_order_import_status_parsing_description(inputs)
	if (locale === "es") return es_work_order_import_status_parsing_description(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_status_parsing_description(inputs)
	if (locale === "ja") return ja_work_order_import_status_parsing_description(inputs)
	if (locale === "hi") return hi_work_order_import_status_parsing_description(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_status_parsing_description(inputs)
	return en_work_order_import_status_parsing_description(inputs)
});